export const FORM_TYPE = {
  DX: 0,
  CUSTOM: 1,
};

export const ACTIVITY_LEVELS = {
  "계획수준": 0,
  "탐색수준": 1,
  "감각수준": 2,
  "반사수준": 3
};

export const ACTIVITY_LEVEL_LABELS = ["계획수준", "탐색수준", "감각수준", "반사수준"];